<template>
  <div class="table-list">
      <el-table class="table-list" :data="items" v-loading="loading" height='100%' width="100%" ref="table">
        <template  v-for="(col,index) in cols" >
          <el-table-column :key="index"
           :prop="col.prop" :label="col.label" align="center" :formatter="formatter" :min-width="col.width" show-overflow-tooltip>
          </el-table-column>
        </template>
          <el-table-column
           fixed="right" label="操作" align="center" :width="type==='dataSourceReport'||'report'?'240px':'180px'">
            <template slot-scope="scope">
              <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
              <el-button v-if="type!=='process'" type="text" @click="viewRow(scope.row)">预览</el-button>
              <el-dropdown class="cust-dropdown" @command="handleCommand($event, scope.row)">
                <span class="el-dropdown-link">
                  <i class="fa fa-chevron-circle-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="type==='dataSourceReport'" command="quoteRow">引用</el-dropdown-item>
                  <el-dropdown-item command="saveAs">复制</el-dropdown-item>
                  <el-dropdown-item command="getHistory">历史</el-dropdown-item>
                  <el-dropdown-item v-if="type==='form'" command="formquoteRow">引用</el-dropdown-item>
                  <el-dropdown-item v-if="type!=='process'&&type!=='report'&&type!=='dataSourceReport'" command="editOutsideChain">公开发布</el-dropdown-item>
                  <el-dropdown-item v-if="type==='report'||type==='dataSourceReport'" command="resetReport">重置</el-dropdown-item>
                  <el-dropdown-item command="print">打印模板</el-dropdown-item>
                  <el-dropdown-item command="delRow">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-footer height="32px" class="pagination-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </el-footer>
    <public-history :parameter="historyParameter"></public-history>
    <public-print-list :parameter="printParameter"></public-print-list>
    <form-quote-list :parameter="formQuoteParameter"></form-quote-list>
  </div>

</template>

<script>
import moment from 'moment'
import PublicHistory from './public-history'
import publicPrintList from './public-print-list'
import formQuoteList from './form-quote-list'
import { Loading } from 'element-ui'
export default {
  name: 'table-list',
  props: ['items', 'loading', 'cols', 'pagination', 'type'],
  watch: {
    'pagination.currentPage' (val) {
      this.$emit('changePagination', this.pagination)
    },
    'pagination.pageSize' (val) {
      this.$emit('changePagination', this.pagination)
    }
  },
  components: {
    PublicHistory,
    publicPrintList,
    formQuoteList
  },
  data () {
    return {
      historyParameter: {visable: false, type: '', id: ''},
      printParameter: {visable: false, name: '', id: '', type: ''},
      copyLoading: {},
      formQuoteParameter: {visable: false, id: ''}
    }
  },

  methods: {
    formatter (row, column) {
      var data = row[column.property]
      // 判断是不是日期
      if (column.property === 'createTime' || column.property === 'lastModifiedDate') {
        return data && moment(data).format('YYYY-MM-DD HH:mm:ss')
      }
      if (column.property === 'publish') {
        return column.property ? '是' : '否'
      }
      // 表单和报表的版本
      if (this.type !== 'process' && column.property === 'version') {
        return '1'
      }
      return data
    },
    editRow (row) {
      this.$emit('editRow', row)
    },
    editOutsideChain (row) {
      this.$emit('editOutsideChain', row)
    },
    saveAs (row) {
      this.copyLoading = Loading.service({
        lock: false,
        text: '正在复制, 请稍后...',
        customClass: 'loading',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.4)'
      })
      this.$nextTick(() => this.$emit('saveAs', row, this.copyLoading))
    },
    delRow (row) {
      this.$emit('delRow', row)
    },
    viewRow (row) {
      this.$emit('viewRow', row)
    },
    quoteRow (row) {
      this.$emit('quoteRow', row)
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    },
    getHistory (row) {
      this.historyParameter.type = this.type
      this.historyParameter.id = row.id
      this.historyParameter.visable = true
    },
    print (row) {
      this.printParameter.name = `${row.name}打印模板`
      this.printParameter.visable = true
      this.printParameter.id = row.id
      this.printParameter.type = this.type
    },
    handleCommand (e, row) {
      this[e](row)
    },
    resetReport (row) {
      this.$confirm('', '重置后将重新设计该报表，确认重置？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'deleMessageBox',
        center: true
      }).then(res => {
        this.$emit('resetReport', row)
      }).catch(() => {})
    },
    formquoteRow (row) {
      this.formQuoteParameter.id = row.id
      this.formQuoteParameter.visable = true
    }
  }
}
</script>

<style lang="scss">
.table-list {
  height: 100%;
  .cust-dropdown {
    .el-dropdown-link {
      width: 12px;
      height: 12px;
      line-height: 12px;
      display: inline-block;
      margin-left: 10px;
      cursor: pointer;
      color: #C5DFFF;

      &:hover {
        color: #8CCDFF;
      }
    }
  }
}

.loading {
  .el-loading-spinner {
    .el-loading-text {
      width: 260px;
      height: 68px;
      line-height: 68px;
      text-align: center;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 4px;
      color: #000000;
    }
    .circular {
      display: none;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/shared/table-list.vue